import { TrendingDown, TrendingUp, DollarSign, Store } from "lucide-react";

export function PriceHistoryOverviewCard({priceHistoryMetrics}) {
  const metrics = [
    {
      id: 1,
      label: "Média de inflação",
      value: priceHistoryMetrics ? priceHistoryMetrics.media_inflacao : "N/A",
      subtext: "Últimos 3 meses",
      trend: "up",
      icon: TrendingUp,
      color: "var(--color-danger)"
    },
    {
      id: 2,
      label: "Produtos mais baratos encontrados",
      value: priceHistoryMetrics ? priceHistoryMetrics.produtos_mais_baratos_encontrados : "N/A",
      subtext: "Este mês",
      trend: "down",
      icon: TrendingDown,
      color: "var(--color-primary)"
    },
    {
      id: 3,
      label: "Economia contra a média",
      value: priceHistoryMetrics ? priceHistoryMetrics.economia_contra_media : "N/A",
      subtext: "Por item nesse mês",
      icon: DollarSign,
      color: "var(--color-text-secondary)"
    },
    {
      id: 4,
      label: "Mercados rastreados",
      value: priceHistoryMetrics ? priceHistoryMetrics.mercados_rastreados : "N/A",
      subtext: "Ativos",
      icon: Store,
      color: "var(--color-text-secondary)"
    }
  ];

  return (
    <div className="card custom-card h-100">
      <div className="card-body p-4">
        <div className="row g-3">
          {metrics.map((metric) => (
            <div key={metric.id} className="col-12 col-sm-6">
              <div className="summary-box">
                <div className="d-flex align-items-start justify-content-between">
                  <div>
                    <p className="small text-muted-custom mb-2">{metric.label}</p>
                    <h4 className="h3 fw-bold mb-1">{metric.value}</h4>
                    <p className="small text-muted-custom mb-0">{metric.subtext}</p>
                  </div>
                  <div className="icon-container" style={{ backgroundColor: `${metric.color}20` }} >
                    <metric.icon size={20} style={{ color: metric.color }} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
